import {createContext, useContext} from 'react';

export const initialPricingPopupValues = {
  featuresProperties: [],
  featureGroupsChecked: [],
  allCatalogsChecked: [],
  activeCatalog: null, // {}
  assignCatalogFeatures: [] // featureDefinitionId,
};

const PricingPopupContext = createContext({});

export const usePricingPopupContext = () => {
  return useContext(PricingPopupContext);
}

export const pricingPopupContextReducer = (state = initialPricingPopupValues, action) => {
  return {...state, ...action};
}

export default PricingPopupContext;
